import(/* webpackMode: "eager" */ "/app/app/articles/seo-vs-pseo-vs-geo-2025/page.tsx");
